/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunColorListDTO } from './RunColorListDTO';
import {
    RunColorListDTOFromJSON,
    RunColorListDTOFromJSONTyped,
    RunColorListDTOToJSON,
} from './RunColorListDTO';

/**
 * 
 * @export
 * @interface RunColorListsDTO
 */
export interface RunColorListsDTO {
    /**
     * Color lists sorted by name
     * @type {Array<RunColorListDTO>}
     * @memberof RunColorListsDTO
     */
    colorLists: Array<RunColorListDTO>;
}

/**
 * Check if a given object implements the RunColorListsDTO interface.
 */
export function instanceOfRunColorListsDTO(value: object): value is RunColorListsDTO {
    if (!('colorLists' in value) || value['colorLists'] === undefined) return false;
    return true;
}

export function RunColorListsDTOFromJSON(json: any): RunColorListsDTO {
    return RunColorListsDTOFromJSONTyped(json, false);
}

export function RunColorListsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunColorListsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'colorLists': ((json['colorLists'] as Array<any>).map(RunColorListDTOFromJSON)),
    };
}

export function RunColorListsDTOToJSON(value?: RunColorListsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'colorLists': ((value['colorLists'] as Array<any>).map(RunColorListDTOToJSON)),
    };
}

